import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import AdRevenueQuery from '../components/AdRevenueQuery.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import DataDashboard from '../components/DataDashboard.vue'
import IpBlacklistManagement from '../components/IpBlacklistManagement.vue'
import UserManagement from '../components/UserManagement.vue'  // 新增用户管理组件导入
import DistributionAccountManagement from '../components/DistributionAccountManagement.vue'  // 新增分销账户管理组件导入
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'  // 新增用户提现管理组件导入
import CoinFlowManagement from '../components/CoinFlowManagement.vue'  // 新增金币流水管理组件导入
import VersionUpdateLogManagement from '../components/VersionUpdateLogManagement.vue'  // 新增版本更新日志管理组件导入
import OfficialInviteCode from '../components/OfficialInviteCode.vue'  // 新增官方邀请码管理组件导入

// 忽略重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const router = new Router({
  mode: 'history', // 添加这一行以启用history模式
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/data-dashboard',
      name: 'DataDashboard',
      component: DataDashboard
    },
    {
      path: '/main',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: '/ad-revenue'
        },
        {
          path: '/ad-revenue',
          name: 'AdRevenueQuery',
          component: AdRevenueQuery
        },
        {
          path: '/system/config',
          name: 'SystemConfigManagement',
          component: SystemConfigManagement
        },
        {
          path: '/ip-blacklist',
          name: 'IpBlacklistManagement',
          component: IpBlacklistManagement
        },
        {
          path: '/user-management',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: '/distribution-account',
          name: 'DistributionAccountManagement',
          component: DistributionAccountManagement
        },
        {
          path: '/user-withdrawal',
          name: 'UserWithdrawalManagement',
          component: UserWithdrawalManagement
        },
        {
          path: '/coin-flow',
          name: 'CoinFlowManagement',
          component: CoinFlowManagement
        },
        {
          path: '/version-log',
          name: 'VersionUpdateLogManagement',
          component: VersionUpdateLogManagement
        },
        {
          path: '/official-invite-code',
          name: 'OfficialInviteCode',
          component: OfficialInviteCode
        }
      ]
    }
  ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.path === '/login') {
    // 如果去的是登录页，且已经有 token，直接跳转到主页
    if (token) {
      next('/ad-revenue')
    } else {
      next()
    }
  } else if (to.path === '/') {
    // 访问根路径时，根据是否有 token 决定去向
    if (token) {
      next('/ad-revenue')
    } else {
      next('/login')
    }
  } else {
    // 如果去的是受保护路由，检查是否有 token
    if (token) {
      next()
    } else {
      // 没有 token，跳转到登录页
      next('/login')
    }
  }
})

export default router